import React from 'react';
import ReactDOM from 'react-dom/client';

// Bootstrap CSS, Icons & JS Bundle
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Font Awesome (if still used)
import '@fortawesome/fontawesome-free/css/all.min.css';

// Your global resets / variables
import './css/index.css';

// ─── Drivers table dark-mode overrides ───
import './css/Drivers.css';

import App from './App';
import { ThemeProvider } from './context/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
